import React from 'react';
import './navi-stick.scss';
import { Box, Container, Grid } from '@mui/material';
import SEO from '../../seo/SEO';

function NaviStick() {
  const routeData = [
    { id: 1, title: 'Katra', distance: '0 KM' },
    { id: 2, title: 'Banganga', distance: '1.5 KM' },
    { id: 3, title: 'Charan Paduka', distance: '3.5 KM' },
    { id: 4, title: 'Adhkuwari', distance: '6 KM' },
    { id: 5, title: 'Himkoti', distance: '8.5 KM' },
    { id: 6, title: 'Bhawan', distance: '13 KM' },
  ];

  const helpData = [
    {
      id: 1,
      title: 'Reduce Fatigue',
      description: 'Provides physical support throughout the climb.',
      icon: '/assets/navi-stick/icon1.svg',
    },
    {
      id: 2,
      title: 'Improve Balance',
      description: 'Offers stability on steep and uneven paths.',
      icon: '/assets/navi-stick/icon2.svg',
    },
    {
      id: 3,
      title: 'Trekking Support',
      description: 'Designed to make your yatra easier and safer.',
      icon: '/assets/navi-stick/icon3.svg',
    },
  ];

  const nightListData = [
    {
      id: 1,
      text: 'Illuminates the path ahead',
      icon: '/assets/navi-stick/icon7.svg',
    },
    {
      id: 2,
      text: 'Improves visibility',
      icon: '/assets/navi-stick/icon8.svg',
    },
    {
      id: 3,
      text: 'Enhances safety during night treks',
      icon: '/assets/navi-stick/icon9.svg',
    },
  ];

  const pressListData = [
    {
      id: 1,
      title: 'Fatigue',
      icon: '/assets/navi-stick/icon10.svg',
    },
    {
      id: 2,
      title: 'Dizziness',
      icon: '/assets/navi-stick/icon11.svg',
    },
    {
      id: 3,
      title: 'Medical Emergencies',
      icon: '/assets/navi-stick/icon12.svg',
    },
    {
      id: 4,
      title: 'Getting Separated',
      icon: '/assets/navi-stick/icon13.svg',
    },
  ];

  const pressBenefitsData = [
    {
      id: 1,
      title: 'Notify Family',
      description: 'Instant alert sent to your registered contacts.',
      icon: '/assets/navi-stick/icon6.svg',
    },
    {
      id: 2,
      title: 'Share Location',
      description: 'Live location shared in real-time.',
      icon: '/assets/navi-stick/icon5.svg',
    },
    {
      id: 3,
      title: 'Trigger Alerts',
      description: 'Local support teams get notified quickly.',
      icon: '/assets/navi-stick/icon4.svg',
    },
  ];

  return (
    <div className="navi-stick-page">
      <SEO pageKey="naviStick" />
      {/* ==================== 1. HERO SECTION ==================== */}
      <Box className="hero-banner">
        <Container maxWidth="lg">
          <Grid container alignItems="center">
            <Grid size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="hero-content">
                <h1>The Journey is Sacred,</h1>
                <p className="hero-desc">
                  Every year, millions of devotees undertake the 13 km journey to seek the blessings of{' '}
                  <strong>Mata Vaishno Devi.</strong>
                </p>
                <ul className="hero-list">
                  <li>
                    <span className="arrow-circle">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                    Some walk comfortably.
                  </li>
                  <li>
                    <span className="arrow-circle">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                    Others face fatigue,
                  </li>
                  <li>
                    <span className="arrow-circle">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                    Steep climbs,
                  </li>
                  <li>
                    <span className="arrow-circle">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                    Crowded pathways,
                  </li>
                  <li>
                    <span className="arrow-circle">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffffff"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                    And unexpected emergencies.
                  </li>
                </ul>
                <div className="hero-buttons">
                  <a href="/contact-us" className="btn-reserve">
                    RESERVE YOUR NAVI STICK
                  </a>
                  <a href="#howItHelps" className="btn-learn">
                    SEE HOW IT HELPS
                  </a>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ==================== 2. THE ROUTE SECTION ==================== */}
      <section className="route-section">
        <Container maxWidth="lg">
          <div className="route-header">
            <h2>The Route (13 KM of Faith)</h2>
            <p>Every step demands energy and endurance.</p>
          </div>

          <div className="route-grid">
            {routeData.map((item) => (
              <div key={item.id} className="route-item">
                <div className="pin-wrapper">
                  <div className="count-badge">{item.id}</div>
                  <div className="pin-icon">
                    <svg
                      width="18"
                      height="25"
                      viewBox="0 0 29 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.5 0C10.6544 0 6.96623 1.52767 4.24695 4.24695C1.52767 6.96623 0 10.6544 0 14.5C0 22.5072 14.5 38.6667 14.5 38.6667C14.5 38.6667 29 22.5072 29 14.5C29 10.6544 27.4723 6.96623 24.753 4.24695C22.0338 1.52767 18.3456 0 14.5 0ZM14.5 23.3611C12.7474 23.3611 11.0342 22.8414 9.57703 21.8677C8.11983 20.8941 6.98408 19.5102 6.3134 17.891C5.64272 16.2718 5.46725 14.4902 5.80915 12.7713C6.15106 11.0524 6.995 9.4735 8.23425 8.23425C9.4735 6.995 11.0524 6.15106 12.7713 5.80915C14.4902 5.46725 16.2718 5.64272 17.891 6.3134C19.5102 6.98408 20.8941 8.11983 21.8677 9.57703C22.8414 11.0342 23.3611 12.7474 23.3611 14.5C23.3611 16.8501 22.4275 19.104 20.7658 20.7658C19.104 22.4275 16.8501 23.3611 14.5 23.3611Z"
                        fill="white"
                      />
                      <path
                        d="M14.5004 18.5278C16.7249 18.5278 18.5282 16.7245 18.5282 14.5C18.5282 12.2755 16.7249 10.4722 14.5004 10.4722C12.276 10.4722 10.4727 12.2755 10.4727 14.5C10.4727 16.7245 12.276 18.5278 14.5004 18.5278Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
                <h5>{item.title}</h5>
                <span>{item.distance}</span>
              </div>
            ))}
          </div>

          <div className="route-info-card">
            <svg
              className="mountain-svg"
              width="38"
              height="28"
              viewBox="0 0 52 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1752_377_navi)">
                <path
                  d="M50.9929 27.649C50.9376 28.4884 50.5732 29.0736 50.1769 28.9561C45.7551 27.6405 39.8052 19.1987 37.9653 16.4535C36.2967 20.5581 34.328 23.5538 33.0526 25.2592C34.8823 26.5536 36.7158 27.5383 38.486 28.0948C38.8808 28.2189 39.1535 28.9993 39.095 29.8378C39.0418 30.6002 38.7333 31.1481 38.381 31.1481C38.3458 31.1481 38.3101 31.1426 38.2744 31.1312C34.6522 29.9926 30.5572 27.0899 26.432 22.7374C23.0008 19.1169 19.7951 14.7537 17.3252 10.3539C15.8271 13.5115 10.8919 22.4156 0.891115 27.4999C0.502423 27.6968 0.113007 27.189 0.0199895 26.3646C-0.0728219 25.5401 0.166382 24.712 0.554558 24.5146C12.0879 18.6512 16.6737 7.36217 16.7186 7.24881C16.8437 6.9335 17.0239 6.73704 17.2176 6.70612C17.4121 6.67586 17.6031 6.80984 17.749 7.08195C20.9387 13.0316 26.0018 19.6122 31.283 23.9118C32.1036 22.951 35.1157 19.1908 37.2723 13.4186C37.5142 12.7715 37.958 12.647 38.2674 13.1372C38.3396 13.2506 45.5595 24.4824 50.3774 25.916C50.7727 26.0337 51.0483 26.8095 50.9929 27.649ZM28.5487 32.1701C28.4058 32.5337 28.2005 32.7211 27.9937 32.7211C27.8304 32.7211 27.666 32.6041 27.5309 32.3642C27.2246 31.8208 27.1837 30.8528 27.4395 30.2024C27.7427 29.4317 28.0927 28.6382 28.4801 27.8442C28.7675 27.2557 29.2248 27.273 29.5019 27.8828C29.7791 28.4928 29.7708 29.4644 29.4836 30.0531C29.1335 30.7712 28.8189 31.4834 28.5487 32.1701Z"
                  fill="#00C2AF"
                  stroke="#00C2AF"
                />
              </g>
              <defs>
                <clipPath id="clip0_1752_377_navi">
                  <rect width="52" height="41" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>
              From Katra to Bhawan, the 13 km journey is a test of devotion, determination and faith.
            </p>
          </div>
        </Container>
      </section>

      {/* ==================== 3. NAVI STICK HELPS YOU SECTION ==================== */}
      <section className="help-section" id="howItHelps">
        <Container maxWidth="lg">
          <div className="section-badge">NAVI STICK HELPS YOU:</div>
          <Grid container spacing={3}>
            {helpData.map((item) => (
              <Grid key={item.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <div className="help-card">
                  <div className="icon-circle">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      {/* ==================== 4. WALKING AT NIGHT SECTION ==================== */}
      <Box className="night-trek-section">
        <Container maxWidth="lg">
          <Grid container alignItems="center">
            <Grid size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="night-trek-content">
                <h2>Walking at Night?</h2>
                <p className="night-desc">
                  Many pilgrims prefer travelling during cooler night hours. Dark pathways and uneven surfaces can make the trek difficult.
                </p>
                <div>
                  <span className="led-badge">BUILD-IN LED PATH LIGHT</span>
                </div>
                <ul className="night-list">
                  {nightListData.map((item) => (
                    <li key={item.id}>
                      <span className="icon-circle">
                        <img src={item.icon} alt={item.text} />
                      </span>
                      <span>{item.text}</span>
                    </li>
                  ))}
                </ul>
                <p className="night-tagline">Because faith never stops after sunset.</p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ==================== 5. HELP AT THE PRESS OF A BUTTON SECTION ==================== */}
      <Box className="press-button-section" id="thirdBanner">
        <Container maxWidth="lg">
          <Grid container alignItems="center" justifyContent="flex-end">
            <Grid size={{ xs: 12, md: 6, lg: 6 }}>
              <div className="press-button-content">
                <h2>
                  Help at the Press
                  <br />
                  of a Button
                </h2>
                <p className="press-subtitle">Unexpected situations can happen to anyone.</p>
                <p className="press-desc">
                  Whether it&apos;s fatigue, dizziness, a medical emergency, or getting separated help is just one press away.
                </p>
                <ul className="press-items-list">
                  {pressListData.map((item) => (
                    <li key={item.id}>
                      <span>{item.title}</span>
                      <span className="icon-circle">
                        <img src={item.icon} alt={item.title} />
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ==================== 6. ONE PRESS CAN SECTION (SCREENSHOT MATCH) ==================== */}
      <section className="one-press-section">
        <Container maxWidth="lg">
          <div className="one-press-badge-wrapper">
            <span className="one-press-badge">ONE PRESS CAN</span>
          </div>
          <Grid container spacing={3}>
            {pressBenefitsData.map((item) => (
              <Grid key={item.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <div className="press-card">
                  <div className="icon-circle">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      {/* ==================== 7. COMING SOON SECTION (SCREENSHOT MATCH) ==================== */}
      <section className="coming-soon-section">
        <Container maxWidth="md">
          <div className="pilgrim-safety-banner">
            NOT JUST A STICK, <span>A COMPLETE PILGRIM SAFETY SERVICE</span>
          </div>

          <div className="coming-soon-badge-wrapper">
            <span className="coming-soon-badge">COMING SOON (NAVI STICK)</span>
          </div>

          <p className="coming-soon-text">
            A companion for every step towards Mata Rani. Faith takes you forward.
            <br />
            <strong>We help you stay safe.</strong>
          </p>

          <div className="register-cta-wrapper">
            <a href="/contact-us" className="btn-register-cta">
              <span className="btn-title">REGISTER YOUR INTEREST TODAY</span>
              <span className="btn-subtitle">Be the first to experience a safer pilgrimage.</span>
            </a>
          </div>
        </Container>
      </section>
    </div>
  );
}

export default NaviStick;
